const removeBlockIdRuleFromStylesheet = (cssStyleSheet, blockId) => {
  if (!cssStyleSheet || !blockId) return;

  const { cssRules } = cssStyleSheet;

  Object.entries(cssRules)
    .reverse()
    .forEach(([index, rule]) => {
      const { selectorText } = rule;

      if (selectorText.startsWith(`#${blockId}`)) {
        cssStyleSheet.deleteRule(index);
      }
    });
};

export default removeBlockIdRuleFromStylesheet;
